import { Color } from "../../ontego-ui";
import { styled } from "@mui/material";

const Styled = {};

Styled.DropdownContainer = styled("div")(() => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    boxSizing: "border-box",
    padding: "16px 12px 16px 12px",
    width: 280,
    height: 44,
    backgroundColor: Color.neutral[100],
    cursor: "pointer",
}));

Styled.DropdownText = styled("div")(() => ({
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
}));

Styled.DropdownArrowIcon = styled("div")(() => ({
    color: Color.primary[600],
    width: 24,
    height: 24,
}));

export default Styled;
